import React from 'react';
import { connect } from '@cerebral/react';
import { state, sequences } from 'app/pwa/app.cerebral';
import Screen from './Screen';
import { useText, useConfig } from 'common/hooks';
import { Container, Button } from './elements';

const deps = {
  currentOnboardingIndex: state.account.currentOnboardingIndex,
  getStartedClicked: sequences`account.getStartedClicked`,
};

function Onboarding({
  currentOnboardingIndex,
  getStartedClicked,
}: typeof deps): React.ReactElement {
  const t = useText();
  const { staticUrl } = useConfig();

  const content = [
    {
      title: 'goals.its_2030',
      text: 'goals.goals_are_met',
      imageUrl: `${staticUrl}/images/onboarding/goalsMet.png`,
      theme: 'dark',
    },
    {
      title: 'you.you_matter',
      text: 'you.join_the_story',
      imageUrl: `${staticUrl}/images/onboarding/youMatter.png`,
      theme: 'dark',
    },
    {
      title: 'compete.compete',
      text: 'compete.join_your_team',
      imageUrl: `${staticUrl}/images/onboarding/compete.png`,
      theme: 'light',
    },
    {
      title: 'master.master',
      text: 'master.learn_how',
      imageUrl: `${staticUrl}/images/onboarding/master.png`,
      theme: 'light',
    },
    {
      title: 'impact.make_impact',
      text: 'impact.inspire_others',
      imageUrl: `${staticUrl}/images/onboarding/makeImpact.png`,
      buttonText: 'impact.get_started',
      buttonAction: getStartedClicked,
      theme: 'light',
    },
  ];

  const { title, text, imageUrl, theme, buttonText } =
    content[currentOnboardingIndex];

  return (
    <Container>
      <Screen
        title={t(`account.onboarding.${title}`)}
        text={t(`account.onboarding.${text}`)}
        imageUrl={imageUrl}
        theme={theme}
        buttonText={buttonText && t(`account.onboarding.${buttonText}`)}
        buttonAction={content[currentOnboardingIndex].buttonAction}
        totalSlides={content.length}
      />
      {currentOnboardingIndex !== content.length - 1 && (
        <Button
          onClick={() => {
            getStartedClicked();
          }}
        >
          {t('account.onboarding.skip')}
        </Button>
      )}
    </Container>
  );
}

export default connect(deps, Onboarding);
